import { render } from "./CreateVATRates.vue?vue&type=template&id=6b0e8d36"
import script from "./CreateVATRates.vue?vue&type=script&lang=js"
export * from "./CreateVATRates.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Amaze-Portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__